import * as React from "react";

export const BorderBottomSVG = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="16" width="16" height="16" rx="2" transform="rotate(-90 0 16)" fill="white"/>
<rect x="0.75" y="15.25" width="14.5" height="14.5" rx="1.25" transform="rotate(-90 0.75 15.25)" stroke="#7D8492" stroke-opacity="0.3" stroke-width="1.5"/>
<mask id="path-3-inside-1_3872_5271" fill="white">
<path d="M2 16C0.895431 16 0 15.1046 0 14L0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2Z"/>
</mask>
<path d="M0 16L0 0L0 16ZM16 0V16V0ZM16 14C16 15.933 14.433 17.5 12.5 17.5H3.5C1.567 17.5 0 15.933 0 14C0 14.2761 0.895431 14.5 2 14.5H14C15.1046 14.5 16 14.2761 16 14ZM0 0L16 0L0 0Z" fill={`${props.color ? props.color : "#052f35 "}`} mask="url(#path-3-inside-1_3872_5271)"/>
</svg>

);
